// extracted by mini-css-extract-plugin
export default {"privacy":"CrushLine_privacy__iIvEY","listLink":"CrushLine_listLink__zIhqp"};